import styled from "styled-components";

export const StyledEmployeeProfilesWrapper = styled.div`
    width: 275px;
`;
